export const CALENDAR_YEAR = [
  {
    Value: 0,
    Diff: 0,
    Char: "",
    YearNm: "",
    Start: "",
    End: "",
    YearStart: 0
  },
  {
    Value: 1,
    Diff: 1925,
    Char: "S",
    YearNm: "昭和",
    Start: "19261225",
    End: "19890107",
    YearStart: 1926
  },
  {
    Value: 2,
    Char: "H",
    Diff: 1988,
    YearNm: "平成",
    Start: "19890108",
    End: "20190430",
    YearStart: 1989
  },
  {
    Value: 3,
    Char: "R",
    Diff: 2018,
    YearNm: "令和",
    Start: "20190501",
    End: "",
    YearStart: 2019
  }
];
